import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAppSelector } from "../store/hooks";
import { selectListingById } from "../store/slices/listingsSlice";

type UserHeaderAvatarProps = {};

export const UserHeaderAvatar: React.FC<UserHeaderAvatarProps> = ({}) => {
  // HOOKS
  const navigate = useNavigate();
  const { user } = useAuth();

  // VARS
  const { primaryListingId } = user || {};

  // Get user's listing from Redux if they're logged in
  const userListing = useAppSelector((state) =>
    primaryListingId ? selectListingById(primaryListingId)(state) : null
  );

  return (
    <>
      {userListing ? (
        <button
          className="user-profile-button"
          onClick={() => navigate(`/persons/${userListing.id}`)}
          title="View your profile"
        >
          {userListing.imageUrl && (
            <img
              src={userListing.imageUrl}
              alt={userListing.name}
              className="user-profile-image"
            />
          )}
          <span className="user-profile-name">{userListing.name}</span>
        </button>
      ) : (
        <div className="user-profile-loading">
          <div className="loading-skeleton-circle"></div>
          <div className="loading-skeleton-text"></div>
        </div>
      )}
    </>
  );
};
